import prefersReduceMotion from './prefersReducedMotion';

const prefersReducedMotion = prefersReduceMotion();

export const scrollIntoViewAndFocus = (el: HTMLElement | null) => {
    window.scrollTo({
        top: 100,
        behavior: (prefersReducedMotion ? 'auto' : 'smooth')
    });
    setTimeout(() => {
        el?.focus();
    }, 10);
}